/**
 * 用于带有列表的增删改查
 */
export default {
  data() {
    return {
      // 列表
      tableLoading: false,
      // 翻页
      page: {
        page: 1,
        size: 10
      },
      total: 0
    };
  },
  methods: {
    // 查询
    search() {},

    // 查看详情
    more(id) {
      this.showDetail(id);
    },

    // 新增项目
    add() {
      this.showDetail();
    },

    // 展示详情面板
    showDetail(id) {
      this.isOpenDrawer = true;
      this.$refs.detail.init({ id });
    },

    // 多选
    handleSelectionChange(val) {
      this.mutilChoosePro = val;
    }
  }
};
